import React from "react";
import { Container, Card } from "react-bootstrap";

export default function SettingsMockup() {
  return (
    <Container fluid>
      <h2 className="mb-4" style={{ color: "#1e3c72", fontWeight: 600 }}>Settings</h2>
      <Card className="shadow-sm border-0">
        <Card.Body className="p-4">
          <p className="text-muted mb-0">System settings and User management</p>
        </Card.Body>
      </Card>
    </Container>
  );
}
